module.exports = __webpack_public_path__ + "img/SET_NOYA_DUO.602a670e.jpg";